import { SoftPos } from 'types/softpos';
export const validTransaction = (t: SoftPos.TrxnRaw): boolean => {
  return (
    t.responseCode === '00' &&
    t.responseDescription.includes('Approved') &&
    t.transactionStatus === 'N' &&
    t.txnEffect === 'D'
  );
};
